import { render } from "./AmendBookingResume.vue?vue&type=template&id=62824544&scoped=true&lang=pug"
import script from "./AmendBookingResume.vue?vue&type=script&lang=ts"
export * from "./AmendBookingResume.vue?vue&type=script&lang=ts"

import "./AmendBookingResume.vue?vue&type=style&index=0&id=62824544&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-62824544"

export default script